module.exports = __webpack_public_path__ + "media/images/puzzle/puzzle_109-0f0c442bc7945d381b38b4e7a8d41a3e.png";